export default {
  
  stack: [],
  
  initialized: false,
  
  add: function( modal, fn ){
    
    if( !this.initialized ){
      this.init();
    }
    
    this.stack.push({
      modal:  modal,
      fn:     fn
    });
    
  },
  
  remove: function( modal ){
    
    for( var i=0; i<this.stack.length; i++ ){
      if( this.stack[i] === modal ){
        this.stack.splice( i, 1 );
      }
    }
    
  },
  
  closeAll: function(){
    
    while( this.stack.length > 0 ){
      this.stack.pop().fn();
    }
    
  },
  
  init: function(){
    
    window.addEventListener( 'keydown', ( e ) => {
      
      if( this.stack.length > 0 && e.which == 27 ){ // esc
        this.stack.pop().fn();
      }
      
    });
    
    this.initialized = true;
    
  }
  
};